import { Stack } from '@mui/material';
import { FlowHumanTaskBlockWorkContextContentType } from 'flow-schema';

import { assertNever } from 'common';

import { humanTaskWorkContextContentTypePortalUrls } from './constants';
import {
  BlockValueTemplateField,
  BlockValueTemplateFieldArea,
} from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import {
  BlockSelectField,
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../../ConfigFields/SelectField';

interface HumanTaskWorkContextVariantsProps {
  variant: FlowHumanTaskBlockWorkContextContentType;
  fieldNamePrefix: string;
}

export function HumanTaskWorkContextVariants(props: HumanTaskWorkContextVariantsProps) {
  const { variant, fieldNamePrefix } = props;
  switch (variant) {
    case FlowHumanTaskBlockWorkContextContentType.Ehr:
      return (
        <BlockValueTemplateField
          label="EHR Instance"
          fieldName={`${fieldNamePrefix}.ehrInstance`}
        />
      );
    case FlowHumanTaskBlockWorkContextContentType.Pdf:
      return (
        <BlockValueTemplateField
          label="Path to PDF document"
          fieldName={`${fieldNamePrefix}.documentId`}
        />
      );
    case FlowHumanTaskBlockWorkContextContentType.Url:
      return <BlockValueTemplateField label="URL" fieldName={`${fieldNamePrefix}.url`} />;
    case FlowHumanTaskBlockWorkContextContentType.Markdown:
      return (
        <BlockValueTemplateFieldArea
          label="Markdown Content"
          fieldName={`${fieldNamePrefix}.markdownContent`}
        />
      );
    case FlowHumanTaskBlockWorkContextContentType.File:
      return (
        <BlockValueTemplateField
          label="File Reference"
          fieldName={`${fieldNamePrefix}.fileReference`}
        />
      );
    case FlowHumanTaskBlockWorkContextContentType.Portal:
      return (
        <BlockSelectField
          label="Portal"
          fieldName={`${fieldNamePrefix}.portal`}
          options={Object.entries(humanTaskWorkContextContentTypePortalUrls).map(
            ([portal, { name }]) => ({ label: name, value: portal })
          )}
        />
      );
    case FlowHumanTaskBlockWorkContextContentType.VoiceCall:
      return (
        <Stack gap={2}>
          <ParentBlockSelectField
            label="Conversational Voice v1"
            fieldName={`${fieldNamePrefix}.voiceCall.sourceBlockName`}
            helperText={getSourceBlockNameHelperText('voiceCall')}
          />
          <BlockValueTemplateFieldArea
            label="Call Summary"
            fieldName={`${fieldNamePrefix}.callSummary`}
          />
        </Stack>
      );
    case FlowHumanTaskBlockWorkContextContentType.VoiceCallV2:
      return (
        <BlockValueTemplateField
          label="Voice Call ID"
          fieldName={`${fieldNamePrefix}.voiceCallId`}
        />
      );
    default:
      return assertNever('Unknown field type', variant);
  }
}
